// event autoscroll to last message to message box
const ScrollBottom = {
  mounted(this: any) {
    this.el.scrollTop = this.el.scrollHeight;
  },
  updated(this: any) {
    this.el.scrollTop = this.el.scrollHeight;
  },
};

export default ScrollBottom;
